var _rect, _g, _rect2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "url(#paint0_linear_169_160)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_169_160)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.23145,
    y: 24,
    width: 32.6987,
    height: 20.4367,
    rx: 10.2183,
    fill: "url(#paint1_linear_169_160)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.23999,
    y: 6.24023,
    width: 35.4236,
    height: 35.4236,
    rx: 17.7118,
    fill: "url(#paint2_linear_169_160)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_160)",
    filter: "url(#filter1_i_169_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4639 17.0217C33.7652 17.3227 33.0306 17.5322 32.2784 17.6452C32.6301 17.5849 33.1476 16.9513 33.3536 16.6948C33.6665 16.308 33.905 15.8664 34.0569 15.3924C34.0569 15.3572 34.0921 15.3069 34.0569 15.2818C34.0392 15.2721 34.0194 15.267 33.9992 15.267C33.979 15.267 33.9591 15.2721 33.9414 15.2818C33.1246 15.7245 32.2552 16.0624 31.3539 16.2875C31.3225 16.2971 31.2891 16.298 31.2572 16.29C31.2254 16.282 31.1963 16.2655 31.1731 16.2423C31.1029 16.1586 31.0274 16.0797 30.947 16.0059C30.5794 15.6763 30.1623 15.4065 29.7111 15.2064C29.1019 14.9562 28.4439 14.8479 27.7868 14.8896C27.1492 14.9299 26.5267 15.101 25.958 15.3924C25.398 15.6996 24.9058 16.117 24.5111 16.6194C24.0958 17.1365 23.796 17.7366 23.6318 18.3794C23.4965 18.9908 23.4811 19.6227 23.5866 20.24C23.5866 20.3456 23.5866 20.3607 23.4962 20.3456C19.914 19.8176 16.9748 18.5454 14.5733 15.8148C14.4678 15.6941 14.4125 15.6941 14.3271 15.8148C13.2821 17.4039 13.7895 19.9182 15.0958 21.1602C15.2717 21.3262 15.4525 21.4871 15.6434 21.638C15.0445 21.5954 14.4602 21.433 13.9252 21.1602C13.8247 21.0949 13.7694 21.1301 13.7644 21.2508C13.7502 21.4181 13.7502 21.5863 13.7644 21.7536C13.8692 22.5555 14.185 23.3151 14.6793 23.9548C15.1736 24.5944 15.8289 25.0912 16.5779 25.3943C16.7605 25.4726 16.9508 25.5316 17.1457 25.5703C16.5912 25.6796 16.0226 25.6966 15.4626 25.6206C15.342 25.5955 15.2968 25.6608 15.342 25.7765C16.0805 27.7879 17.6832 28.4014 18.8589 28.7434C19.0197 28.7685 19.1804 28.7685 19.3613 28.8088C19.3613 28.8088 19.3613 28.8088 19.3312 28.8389C18.9845 29.4725 17.5828 29.9 16.9397 30.1212C15.7659 30.5432 14.5144 30.7045 13.272 30.5939C13.0761 30.5637 13.0309 30.5688 12.9806 30.5939C12.9304 30.6191 12.9806 30.6744 13.0359 30.7247C13.2871 30.8906 13.5383 31.0364 13.7996 31.1772C14.5773 31.6018 15.3996 31.9391 16.2514 32.183C20.6626 33.3999 25.6264 32.5048 28.9373 29.211C31.5398 26.6263 32.4542 23.0611 32.4542 19.4907C32.4542 19.355 32.62 19.2745 32.7155 19.2041C33.3739 18.6906 33.9544 18.0842 34.4388 17.4039C34.5227 17.3024 34.5657 17.1733 34.5594 17.0418C34.5594 16.9664 34.5594 16.9815 34.4639 17.0217Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_169_160",
    x: 1.77145,
    y: 18.54,
    width: 43.6187,
    height: 31.3575,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73,
    result: "effect1_foregroundBlur_169_160"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_169_160",
    x: 12.96,
    y: 12.9609,
    width: 21.6,
    height: 22.0996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_169_160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_160",
    x1: 4.03493,
    y1: 3.1441,
    x2: 39.6681,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDDE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_160",
    x1: 7.89606,
    y1: 24,
    x2: 22.3068,
    y2: 52.8669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05ABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_169_160",
    x1: 6.95999,
    y1: 6.24023,
    x2: 37.44,
    y2: 44.4002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CA8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 21.6,
    fill: "white",
    transform: "translate(12.96 12.9609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.5fb16d49490584e78af33fc4e8a167f3.svg";
export { ForwardRef as ReactComponent };